<template>
    <form @submit.prevent="submit()" @keydown="form.clearError($event.target.name)">
        <b-row>
            <b-col lg="6">
                <b-card header="Service Address Landline"
                    header-bg-variant="info"
                    header-text-variant="white">
                    <b-row>
                        <b-col lg="9" sm="9" xs="12">
                            <b-form-group label="Phone Number" label-for="service_number" :state=" validServiceNumber " invalid-feedback="Must be 10 digits long!">
                                <mask-input name="number"
                                    v-model="form.service_number"
                                    id="service_number"
                                    :disabled=" (!create && isCarrierManager) || readonly "
                                ></mask-input>
                                <input-help :form="form" field="service_number" text="Enter full phone number."></input-help>
                            </b-form-group>
                        </b-col>
                        <b-col lg="3" sm="3" xs="12">
                            <b-form-group label="Extension" label-for="service_extension">
                                <b-form-input
                                        id="service_extension"
                                        name="extension"
                                        type="number"
                                        maxlength="5"
                                        v-model="form.service_extension"
                                        class="input-sm"
                                        :disabled=" (!create && isCarrierManager) || readonly "
                                >
                                </b-form-input>
                                <input-help :form="form" field="service_extension" text="Enter an extension (optional)."></input-help>
                            </b-form-group>
                        </b-col>
                    </b-row>
                </b-card>
            </b-col>
            <b-col lg="6">
                <b-card header="Contact Phone"
                    header-bg-variant="info"
                    header-text-variant="white">
                    <b-row>
                        <b-col lg="9" sm="9" xs="12">
                            <b-form-group label="Phone Number" label-for="contact_number" invalid-feedback="Must be 10 digits long!" :state=" validContactNumber ">
                                <mask-input name="number"
                                    v-model="form.contact_number"
                                    id="contact_number"
                                    :disabled="isClient || ( !create && isCarrierManager ) || readonly"
                                ></mask-input>
                                <input-help :form="form" field="contact_number" text="Enter full phone number."></input-help>
                            </b-form-group>
                        </b-col>
                        <b-col lg="3" sm="3" xs="12">
                            <b-form-group label="Extension" label-for="contact_extension">
                                <b-form-input
                                        id="contact_extension"
                                        name="extension"
                                        type="number"
                                        maxlength="5"
                                        v-model="form.contact_extension"
                                        class="input-sm"
                                        :disabled="isClient || ( !create && isCarrierManager ) || readonly"
                                >
                                </b-form-input>
                                <input-help :form="form" field="contact_extension" text="Enter an extension (optional)."></input-help>
                            </b-form-group>
                        </b-col>
                    </b-row>
                    <b-row v-if="isClient">
                        <b-col lg="12" class="text-center">
                            <h3>Please call {{ supportNumber }} if you would like to edit your information.</h3>
                        </b-col>
                    </b-row>
                </b-card>
            </b-col>
        </b-row>
        <b-row>
            <b-col lg="12" v-show=" !readonly ">
                <b-button variant="success" size="lg" type="submit" v-if=" create " :disabled=" !validServiceNumber || !validContactNumber ">Save and Continue</b-button>
                <b-button variant="success" size="lg" type="submit" v-else-if=" !isCarrierManager " :disabled=" !validContactNumber || !validServiceNumber ">Save Profile</b-button>
            </b-col>
        </b-row>
    </form>
</template>

<script>
    import PhoneNumber from './PhoneNumber';
    import UsesRole from "../mixins/UsesRole";

    export default {
        props: {
            'readonly': {
              type: Boolean,
              default: false,
            },
            'client': {},
            'create': Boolean,
            'supportNumber': String,
        },

        mixins: [UsesRole],

        components: {
            PhoneNumber
        },

        computed: {
            validServiceNumber(){

                return [ 0, 10 ].includes( this.form.service_number.replace( /\D/g, '' ).length );
            },
            validContactNumber(){

                return [ 0, 10 ].includes( this.form.contact_number.replace( /\D/g, '' ).length );
            },
        },

        data() {
            return {
                form: new Form({

                    user_id           : this.client.id ? this.client.id : '',
                    contact_number    : this.client.contact_number ? this.client.contact_number.national_number : '',
                    contact_extension : this.client.contact_number ? this.client.contact_number.extension : '',
                    service_number    : this.client.service_number ? this.client.service_number.national_number : '',
                    service_extension : this.client.service_number ? this.client.service_number.extension : '',
                }),
            }
        },

        methods: {
            async submit() {

                if( !this.validServiceNumber || !this.validContactNumber ) return false;

                let url = `${this.claimantUrlPrefix}/${this.client.id}/phone`;

                if (this.isClient) {
                    url = '/profile/phones';
                }

                this.form.put(url)
                    .then( ({ data }) => {
                        if (this.create) {
                            this.$emit('continue');
                        }
                    });
            },
        }
    }
</script>